/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Character_TitleInputs */

const en_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The 2024 Deacon Palmer Award`)
};

const es_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El premio Deacon Palmer 2024`)
};

const de_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Deacon Palmer-Preis 2024`)
};

const zh_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 年 Deacon Palmer 奖`)
};

const ar_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جائزة Deacon Palmer لعام 2024`)
};

const fr_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le prix Deacon Palmer 2024`)
};

const vi_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giải thưởng Deacon Palmer 2024`)
};

const sw_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuzo ya Deacon Palmer ya 2024`)
};

const th_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัล Deacon Palmer ประจำปี 2024`)
};

const bs_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagrada Deacon Palmer 2024`)
};

const ja_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024年 Deacon Palmer賞`)
};

const ko_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 Deacon Palmer 상`)
};

const pt_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Prêmio Deacon Palmer 2024`)
};

const it_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il premio Deacon Palmer 2024`)
};

const sv_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer-priset 2024`)
};

const nl_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Deacon Palmer Award 2024`)
};

const da_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer-prisen 2024`)
};

const nb_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer-prisen 2024`)
};

const fi_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer -palkinto 2024`)
};

const pl_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagroda Deacon Palmer 2024`)
};

const ru_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премия Deacon Palmer 2024 года`)
};

const tr_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 Deacon Palmer Ödülü`)
};

const hi_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 Deacon Palmer पुरस्कार`)
};

const id_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghargaan Deacon Palmer 2024`)
};

const ms_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anugerah Deacon Palmer 2024`)
};

const cs_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena Deacona Palmera 2024`)
};

const el_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το βραβείο Deacon Palmer 2024`)
};

const he_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרס Deacon Palmer לשנת 2024`)
};

const af_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die 2024 Deacon Palmer-toekenning`)
};

const hu_about_character_title = /** @type {(inputs: About_Character_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 2024-es Deacon Palmer-díj`)
};

/**
* | output |
* | --- |
* | "The 2024 Deacon Palmer Award" |
*
* @param {About_Character_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_character_title = /** @type {((inputs?: About_Character_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Character_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_character_title(inputs)
	if (locale === "de") return de_about_character_title(inputs)
	if (locale === "zh") return zh_about_character_title(inputs)
	if (locale === "ar") return ar_about_character_title(inputs)
	if (locale === "fr") return fr_about_character_title(inputs)
	if (locale === "vi") return vi_about_character_title(inputs)
	if (locale === "sw") return sw_about_character_title(inputs)
	if (locale === "th") return th_about_character_title(inputs)
	if (locale === "bs") return bs_about_character_title(inputs)
	if (locale === "ja") return ja_about_character_title(inputs)
	if (locale === "ko") return ko_about_character_title(inputs)
	if (locale === "pt") return pt_about_character_title(inputs)
	if (locale === "it") return it_about_character_title(inputs)
	if (locale === "sv") return sv_about_character_title(inputs)
	if (locale === "nl") return nl_about_character_title(inputs)
	if (locale === "da") return da_about_character_title(inputs)
	if (locale === "nb") return nb_about_character_title(inputs)
	if (locale === "fi") return fi_about_character_title(inputs)
	if (locale === "pl") return pl_about_character_title(inputs)
	if (locale === "ru") return ru_about_character_title(inputs)
	if (locale === "tr") return tr_about_character_title(inputs)
	if (locale === "hi") return hi_about_character_title(inputs)
	if (locale === "id") return id_about_character_title(inputs)
	if (locale === "ms") return ms_about_character_title(inputs)
	if (locale === "cs") return cs_about_character_title(inputs)
	if (locale === "el") return el_about_character_title(inputs)
	if (locale === "he") return he_about_character_title(inputs)
	if (locale === "af") return af_about_character_title(inputs)
	if (locale === "hu") return hu_about_character_title(inputs)
	return en_about_character_title(inputs)
});